<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-module-submodule-select
              ref="smComboFrame0"
              class="dp_flex"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              defaultMdOption="all"
              defaultSmdOption="all"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MASS_EXTC_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-yn-select
              ref="comboUseYn"
              :selected="frame0.selectData.COD_BIG_QUANTITY_YN"
              :defaultOption="'all'"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_EXTC_TYPE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-text-field
              v-model="frame0.selectData.nameSearchText"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="listGrid"
        :columns="gridColumns"
        :dataset="'dataset0'"
        :showDisplayCountControl="false"
        :enabletooltips="true"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancelClick"
        >
          {{ $t("MSG_BTN_CANCEL") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSelectClick"
        >
          {{ $t("MSG_BTN_SELT") }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

// const dateTypeFields = ['firstRegistrationDTM', 'finalModificationDTM'];
export default {
  name: 'PGE_CMS_00011', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default() {
        return null;
      },
    },
    pageInitialData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_BIG_QUANTITY_YN: {
            label: '',
            key: '',
          },
          nameSearchText: '',
        },
      },
      localdata0: [
      ],
      gridColumns: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_DATA_EXTC_TYPE_NM'),
        datafield: 'dataExtractionTypeName',
      }, {
        text: this.$t('MSG_TXT_MASS_EXTC'),
        datafield: 'dataExtractionBigQuantityYn',
      }, {
        text: this.$t('MSG_TXT_EXPL'),
        datafield: 'dataExtractionContent',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextarea(row, column, value, htmlElement, {
            positiveButtonText: this.$t('MSG_BTN_CFRM'),
            checkEditableFunction: this.checkEditableFunction,
          }, this.dataset0, this.$refs.listGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      {
        name: 'moduleName',
        type: 'string',
        map: 'moduleName',
      }, {
        name: 'subModuleName',
        type: 'string',
        map: 'subModuleName',
      }, {
        name: 'dataExtractionTypeName',
        type: 'string',
        map: 'dataExtractionTypeName',
      }, {
        name: 'dataExtractionBigQuantityYn',
        type: 'string',
        map: 'dataExtractionBigQuantityYn',
      }, {
        name: 'firstRegistrationUserId',
        type: 'string',
        map: 'firstRegistrationUserId',
      }, {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      }, {
        name: 'displayLanguageId',
        type: 'string',
        map: 'displayLanguageId',
      }, {
        name: 'knoxId',
        type: 'string',
        map: 'knoxId',
      }, {
        name: 'userName',
        type: 'string',
        map: 'userName',
      }, {
        name: 'userGlobalName',
        type: 'string',
        map: 'userGlobalName',
      }, {
        name: 'dataExtractionContent',
        type: 'string',
        map: 'dataExtractionContent',
      },

    ],
  }],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onResetClick() {
      // this.$refs.smComboFrame0.reset();
      this.$refs.smComboFrame0.selectMd('ALL');
      this.$refs.comboUseYn.reset();
      this.frame0.selectData.nameSearchText = '';
    },
    onSearchClick() {
      const codeValue = this.frame0.selectData;
      const queryParams = {
        moduleCode: utils.trim(codeValue.COD_MDLE.key),
        subModuleCode: utils.trim(codeValue.COD_SMDLE.key),
        dataExtractionBigQuantityYn: utils.trim(codeValue.COD_BIG_QUANTITY_YN.key),
        dataExtractionTypeName: utils.trim(this.frame0.selectData.nameSearchText),
        dataExtractionTypeUseYn: 'Y',
      };

      http.request(this.$options.name, 'DTS_CMS_00028', {
        query: queryParams,
      }).then(res => {
        // utils.dateformatToClientInArray(res.data, dateTypeFields);
        this.localdata0 = res.data;
        this.dataset0.setRawData(this.localdata0);
      }).catch(error => {
        console.log(error);
      });
    },
    onCancelClick() {
      this.closePagePopup('');
    },
    onSelectClick() {
      const selectedData = this.dataset0.getSelectedRawData();
      if (selectedData.length > 0) {
        this.closePagePopup(selectedData);
      } else {
        // 선택 안했을 때
        utils.messageBox('information', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    checkEditableFunction() {
      return false;
    },
  },
};

</script>
<style scoped>
</style>
